<template>
  <div>
    <h3>Liste des transporteur</h3>
    <table>
      <tr>
        <th>Nom</th>
        <th>Logo</th>
        <th>Descritpion</th>
        <th>Etat</th>
        <th>Position</th>
        <th>Editer</th>
        <th>Supprimer</th>
        <th>Positionner</th>
      </tr>
      <tr
        v-for="transporteur of transporteurs"
        :key="transporteur.id"
      >
        <td>{{ transporteur.nom }}</td>
        <td>{{ transporteur.logo }}</td>
        <td>{{ transporteur.description }}</td>
        <td>
          <input
            name="enable"
            type="checkbox"
            v-model="transporteur.etat"
            @change="updateTransporteur(transporteur)"
          >
        </td>
        <td>{{ transporteur.position }}</td>
        <td>
          <button
            @click.prevent="editTransporteur(transporteur.id)"
          >
            Editer
          </button>
        </td>
        <td>
          <button
            @click.prevent="deleteTransporteur(transporteur.position)"
          >
            Supprimer
          </button>
        </td>
        <td>
          <button
            @click.prevent="moveTransporteur(transporteur.position, 'up')"
          >
            ▲
          </button>
          <button
            @click.prevent="moveTransporteur(transporteur.position, 'down')"
          >
            ▼
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    transporteurs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data: function() { return {} },
  methods: {
    editTransporteur: function(id) {
      this.$emit('edit-transporteur', id)
    },
    deleteTransporteur: function(position) {
      this.$emit('delete-transporteur', position)
    },
    moveTransporteur: function(position, move) {
      this.$emit('move-transporteur', { position, move })
    },
    updateTransporteur: function(transporteur) {
      this.$emit('update-transporteur', transporteur)
    }
  }
}
</script>
<style scoped>
  .transporteur-nom {
    display: inline-block;
    width: 30%;
  }
  table button {
    vertical-align: right;
  }
</style>